/**
 * Preloader Module
 * 
 * @package KateMedia
 */

export function initPreloader() {
    const preloader = document.getElementById('preloader');
    
    if (!preloader) {
        return;
    }
    
    const paths = preloader.querySelectorAll('.preloader__path');
    
    if (paths.length === 0) {
        return;
    }
    
    function startFillAnimation() {
        if (!paths || paths.length === 0) {
            return;
        }
        
        // Устанавливаем все пути в начальное состояние
        paths.forEach((path, index) => {
            if (path && path.style) {
                // Контуры уже видны, только устанавливаем прозрачную заливку
                path.style.fill = 'transparent';
                path.style.opacity = '1';
                
                // Принудительно перерисовываем
                path.offsetHeight;
            }
        });
        
        // Запускаем анимацию закраски с небольшой задержкой для стабилизации
        setTimeout(() => {
            if (!paths || paths.length === 0) return;
            
            paths.forEach((path, index) => {
                if (path && path.style) {
                    // Добавляем плавный переход для заливки
                    path.style.transition = 'fill 1.2s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
                    
                    // Запускаем анимацию закраски с задержкой
                    setTimeout(() => {
                        if (path && path.style) {
                            path.style.fill = 'white';
                        }
                    }, index * 200);
                }
            });
        }, 100);
    }
    
    function hidePreloader() {
        if (!preloader) return;
        
        preloader.classList.add('preloader--hidden');
        
        setTimeout(() => {
            if (preloader && preloader.parentNode) {
                preloader.parentNode.removeChild(preloader);
            }
        }, 500);
    }
    
    function forceStartAnimation() {
        paths.forEach((path, index) => {
            if (path && path.style) {
                path.style.animation = 'none';
                path.style.animationDelay = '0s';
                path.style.fill = 'transparent';
                path.style.opacity = '1';
            }
        });
        
        startFillAnimation();
    }
    
    function initAnimation() {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => {
                setTimeout(startFillAnimation, 50);
            });
        } else if (document.readyState === 'interactive') {
            setTimeout(startFillAnimation, 50);
        } else {
            startFillAnimation();
        }
    }
    
    initAnimation();
    
    setTimeout(() => {
        const hasAnimation = Array.from(paths).some(path => 
            path && path.style && path.style.fill === 'white'
        );
        
        if (!hasAnimation) {
            forceStartAnimation();
        }
    }, 500);
    
    if (document.readyState === 'complete') {
        setTimeout(hidePreloader, 1600);
    } else {
        window.addEventListener('load', () => {
            setTimeout(hidePreloader, 1600);
        });
    }
    
    setTimeout(() => {
        if (preloader && !preloader.classList.contains('preloader--hidden')) {
            hidePreloader();
        }
    }, 2000);
}
